export default Object.freeze({
  Company: 2,
  Individual: 3,
  Asistente: 5,
  DBA: 7,
});
